import { render, staticRenderFns } from "./RemotePlugins.vue?vue&type=template&id=4afc4532&"
import script from "./RemotePlugins.vue?vue&type=script&lang=js&"
export * from "./RemotePlugins.vue?vue&type=script&lang=js&"
import style0 from "./RemotePlugins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports